<template>
  <div class="w1200 newsBox">
    <!--<div class="top">-->
    <!--<div class="dataBaseTopBox">-->
    <!--<div class="navs">-->
    <!--<div class="w1200s">-->
    <!--<ul class="head-ul">-->
    <!--<li class="'noactive">-->
    <!--<a target="_blank" href="http://www.pengzushijia.com/" class="navli">-->
    <!--平台导航-->
    <!--</a>-->
    <!--</li>-->
    <!--<li :class="currentIndex===0?'avtive':'noactive'" @click="gonav(0)">-->
    <!--<router-link tag="a" :to="{name:'ho',query:{index:0}}" class="navli">-->
    <!--首页-->
    <!--</router-link>-->
    <!--</li>-->
    <!--<li :class="currentIndex===1?'avtive':'noactive'" @click="gonav(1)">-->
    <!--<router-link tag="a" :to="{name:'ne',params:{templateId:'NEWS'},query:{index:1}}" class="navli">-->
    <!--资讯-->
    <!--</router-link>-->
    <!--</li>-->
    <!--<li :class="currentIndex===2?'avtive':'noactive'" @click="gonav(2)">-->
    <!--<router-link tag="a" :to="{name:'at',params:{templateId:'PHOTO'},query:{index:2}}" class="navli">-->
    <!--图集-->
    <!--</router-link>-->
    <!--</li>-->
    <!--<li :class="currentIndex===3?'avtive':'noactive'" @click="gonav(3)">-->
    <!--<router-link tag="a" :to="{name:'vd',params:{templateId:'VIDEO'},query:{index:3}}" class="navli">-->
    <!--视频-->
    <!--</router-link>-->
    <!--</li>-->
    <!--<li :class="currentIndex===4?'avtive':'noactive'" @click="gonav(4)">-->
    <!--<router-link tag="a" :to="{name:'li',params:{templateId:'DOC'},query:{index:4}}" class="navli">-->
    <!--文库-->
    <!--</router-link>-->
    <!--</li>-->
    <!--<li :class="currentIndex===5?'avtive':'noactive'" @click="gonav(5)">-->
    <!--<router-link tag="a" :to="{name:'al',query:{index:5}}" class="navli">-->
    <!--专辑-->
    <!--</router-link>-->
    <!--</li>-->
    <!--<li :class="currentIndex===6?'avtive':'noactive'" @click="gonav(6)">-->
    <!--<router-link tag="a" :to="{name:'sp',query:{index:6}}" class="navli">-->
    <!--专题-->
    <!--</router-link>-->
    <!--</li>-->
    <!--<li :class="currentIndex===7?'avtive':'noactive'" @click="gonav(7)">-->
    <!--<router-link tag="a" :to="{name:'datab'}" class="navli">-->
    <!--总数据库-->
    <!--</router-link>-->
    <!--</li>-->
    <!--&lt;!&ndash;<li :class="currentIndex===8?'avtive':'noactive'" @click="gonav(8)">&ndash;&gt;-->
    <!--&lt;!&ndash;<router-link tag="a" :to="{name:'roots'}" class="navli">&ndash;&gt;-->
    <!--&lt;!&ndash;根籍搜索&ndash;&gt;-->
    <!--&lt;!&ndash;</router-link>&ndash;&gt;-->
    <!--&lt;!&ndash;</li>&ndash;&gt;-->
    <!--<li class="'noactive">-->
    <!--<a target="_blank" href="http://maker.pengzushijia.com/" class="navli">-->
    <!--编撰平台-->
    <!--</a>-->
    <!--</li>-->
    <!--</ul>-->
    <!--<div class="right_box">-->
    <!--<div v-show="!islogin" class="login_register">-->
    <!--<a href="/login">登录</a>-->
    <!--<a href="/register">注册</a>-->
    <!--</div>-->
    <!--<div v-show="islogin" class="userBox">-->
    <!--<div class="imgBox">-->
    <!--<img v-if="userData.USER_PHOTO" :src="userData.USER_PHOTO" alt="">-->
    <!--<img v-else :src="noIMG" alt="">-->
    <!--</div>-->
    <!--<div class="usercontent" @click="goUserMsg(0)">-->
    <!--<el-tooltip class="item" effect="dark" :content="userData.USER_MOBILE" placement="top-start">-->
    <!--<span v-if="userData.USER_NAME">{{ userData.USER_NAME }}</span>-->
    <!--<span v-else>{{ userData.USER_MOBILE }}</span>-->
    <!--</el-tooltip>-->
    <!--</div>-->
    <!--<ul class="list">-->
    <!--<li v-for="(item,index) in arrs" :key="index" @click="goUserMsg(index)">-->
    <!--{{ item.name }}-->
    <!--</li>-->
    <!--</ul>-->
    <!--</div>-->
    <!--</div>-->
    <!--</div>-->
    <!--</div>-->
    <!--<div class="w1200">-->
    <!--<div class="logoBox">-->
    <!--<img :src="logo" alt="">-->
    <!--</div>-->
    <!--<div class="searchbox">-->
    <!--<input v-model="keys" type="text" class="keys_input" placeholder="输入关键字搜索"><div class="btn" @click="goSearch">-->
    <!--一键搜索-->
    <!--</div>-->
    <!--</div>-->
    <!--</div>-->
    <!--</div>-->
    <!--</div>-->
    <div class="w1200" style="overflow: hidden;background-color: #F9F9F9">
      <div class="leftBox">
        <div class="bannerBox">
          <img :src="banner" alt="">
        </div>
        <div>
          <div class="firstcolumn_tip">
            <!--<img :src="pushu" alt="">-->
            推荐谱文
          </div>
          <div class="pushu_nav">
            <div class="columnBoxInnner">
              <div class="columnBoxInnnerList">
                <span v-for="(item,index) in bookType" :key="index" :class="currentPushu==index?'activenames':'names'" @click="gopushu(item,index)"><span class="span_name">{{ item.DICTIONARY_NAME }}</span><span v-if="index!=bookType.length-1" style="margin: 0 8px;">/</span></span>
              </div>
            </div>
          </div>
          <div v-if="bookData.length>0" class="showlist">
            <div v-for="(item,index) in bookData" :key="index" class="lilist">
              <div class="imgBox" @click="goDetail(item.SHOW_RES_ID,item.SHOW_TYPE)">
                <img v-if="item.COVER" :src="item.COVER" alt="">
                <img v-else :src="noIMG_list" alt="">
              </div>
              <div style="display: inline-block;width:605px;height: 145px;margin-left: 30px;vertical-align: top" class="right_div">
                <p style="height: 20px;line-height: 20px;">
                  <span v-if="item.SHOW_IS_TOP=='1'" style="display: inline-block;width: 40px; height: 20px;line-height: 20px;background-color: #CC0000;color: #ffffff;font-size: 14px;border-radius: 5px;text-align: center;margin-right: 10px">置顶</span>
                  <span style="display: inline-block;width: 40px; height: 20px;line-height: 20px;background-color: #7E6B5A;color: #ffffff;font-size: 14px;border-radius: 5px;text-align: center;">书页</span>
                  <span style="margin-left: 10px;cursor: pointer;" @click="goDetail(item.SHOW_RES_ID,item.SHOW_TYPE)">{{ item.SHOW_TITLE }}</span>
                </p>
                <p class="puxi_content" style="font-size: 12px;margin-top: 18px">
                  {{ item.SHOW_ABSTRACT }}
                </p>
                <div style="font-size: 0;margin-top: 15px" class="userMsg">
                  <img v-if="item.USER_PHOTO" :src="item.USER_PHOTO" alt="" style="width: 36px;height: 36px;border-radius: 50%">
                  <img v-else :src="noIMG" alt="" style="width: 36px;height: 36px;border-radius: 50%;vertical-align: top">
                  <span style="margin-left: 10px;display: inline-block;width: 100px;height: 36px;line-height: 36px;color: #999999;font-size: 12px;vertical-align: top">{{ item.USER_NAME }}</span>
                  <span style="color: #999999;font-size: 12px;display: inline-block;height: 36px;line-height: 36px;vertical-align: top">{{ item.CREATE_DATE }}</span>
                </div>
              </div>
              <div class="tip">
                {{ item.DICTIONARY_NAME }}
              </div>
            </div>
          </div>
          <div v-else style="text-align: center;font-size: 20px;color: #a19d9e;font-weight: 600;background-color: #ffffff;height: 150px;line-height: 150px;">
            暂无数据
          </div>
          <div class="addMore">
            <span v-show="!loadAll" class="addMore_span" @click="addMore">加载更多</span>
            <span v-show="loadAll">已经到底了</span>
          </div>
        </div>
      </div>
      <div class="rightBox">
        <Rightlist />
      </div>
    </div>
    <!--<div>2</div>-->
  </div>
</template>
<script>
import Rightlist from '@/components/commonRightList'
import { getClassz, getEditionHtmlLists } from '@/api/api.js'
export default {
  components: { Rightlist },
  head() {
    // var listObj = this.$store.state.hotList_home
    var metaStr = ''
    // listObj.forEach(a => {
    //   metaStr += a.CONTENT_TITLE + ' | '
    // })
    return {
      title: '书页-',
      mateDesc: metaStr
    }
  },
  data() {
    return {
      currerntPage: 1,
      currentType: '',
      loadAll: false,
      bookData: [],
      bookType: [{ DICTIONARY_ID: '', DICTIONARY_NAME: '全部' }],
      currentPushu: 0,
      pushu: require('@/static/shuye.png'),
      banner: require('@/static/shuye_banner.png'),
      noIMG: require('@/static/usuerDefault.png'),
      noIMG_list: require('@/static/shuyeDefault.png'),
      keys: '',
      logo: require('@/static/search_logo_peng.png'),
      currentIndex: 0,
      islogin: false,
      username: '',
      userData: {},
      arrs: [{ 'name': '账号设置' }, { 'name': '我的收藏' }, { 'name': '我的评论' }, { 'name': '我的消息' }, { 'name': '退出登录' }],
      banner_foot: require('@/static/banner_foot.png')
    }
  },
  created() {
    this.initData()
  },
  mounted() {
    this.fn()
    this.initType()
  },
  methods: {
    fn: function() {
      window.scrollTo(0, 0)
    },
    gonav: function(index) {
      this.currentIndex = index
    },
    // /查询字典
    initType() {
      getClassz({ classCode: 'HtmlType' }).then(res => {
        this.bookType = this.bookType.concat(res.data)
        // console.log(res.data)
      })
    },
    initData() {
      getEditionHtmlLists({ page: 1, limit: 12, systemCode: this.systemConfig.systemConfig.sytemName }).then(res => {
        // console.log(res.data)
        this.bookData = res.data.listMapData
        if (res.data.count <= 6) {
          this.loadAll = true
        }
      })
    },
    gopushu(names, index) {
      this.loadAll = false
      this.currerntPage = 1
      this.currentType = names.DICTIONARY_ID
      getEditionHtmlLists({ page: 1, limit: 12, type: names.DICTIONARY_ID, systemCode: this.systemConfig.systemConfig.sytemName }).then(res => {
        this.bookData = res.data.listMapData
        if (res.data.count <= 6) {
          this.loadAll = true
        }
      })
      this.currentPushu = index
    },
    addMore() {
      this.currerntPage++
      getEditionHtmlLists({ page: this.currerntPage, limit: 12, type: this.currentType, systemCode: this.systemConfig.systemConfig.sytemName }).then(res => {
        this.bookData = this.bookData.concat(res.data.listMapData)
        if (res.data.page <= this.currerntPage) {
          this.loadAll = true
        }
      })
    },
    goDetail(sourceId, type) {
      const { href } = this.$router.resolve({
        url: '/sourceView',
        name: 'sourceView',
        query: {
          sourceId,
          type
        }
      })
      window.open(href, '_blank')
    },
    goSearch: function() {
      if (this.keys) {
        this.$router.push({ path: '/search', name: 'search', params: { searchName: this.keys }})
      } else {
        this.$message({
          message: '请输入关键字',
          type: 'warning',
          duration: 1500
        })
      }
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
  .puxi_content{
    height: 40px;
    line-height: 20px;
    font-size: 12px;
    color: #666666;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
  ///列表样式
  .pushu_nav{
    overflow: hidden;
    text-align: center;
    background-color: #fff;
    padding: 20px 0;
    span{
      font-size: 15px;
      color: #333333;
    }
    .names{
      .span_name{
        cursor: pointer;
        color: #333333;
        font-weight: 600;
        font-size: 16px;
      }
    }
    .activenames{
      .span_name{
        cursor: pointer;
        color: #E3003A;
        font-weight: 600;
        font-size: 16px;
      }
    }
  }
  .showlist{
    width: 100%;
    /*overflow: hidden;*/
    font-size: 0;
    background-color: #fff;
    padding-bottom: 20px;
    .lilist{
      padding:20px 0;
      position: relative;
      /*margin-top: 43px;*/
      display: inline-block;
      margin-left: 30px;
      margin-right: 15px;
      width: 835px;
      border-bottom: 1px solid #F1F1F1;
      overflow: hidden;
      .imgBox{
        display: inline-block;
        width: 200px;
        height: 145px;
        overflow: hidden;
        img{
          width: 200px;
          height: 145px;
          cursor: pointer;
        }
      }

      p{
        color: #333333;
        margin-top: 5px;
        font-size: 15px;
        padding-left: 10px;
      }
      .tip{
        position: absolute;
        top: 25px;
        left: 9px;
        display: inline-block;
        width: 60px;
        background-color:rgba(0,0,0,.3);
        color: #ffffff;
        height: 20px;
        line-height: 20px;
        font-size: 12px;
        text-align: center;
        border-radius: 2px;
        cursor: pointer;
        &:hover{
          color: #ed4040;
        }
      }
    }
  }
  .addMore{
    height: 38px;
    border: 1px solid #f0f0f0;
    text-align: center;
    line-height: 40px;
    font-size: 12px;
    background-color: #fff;
    margin-bottom: 30px;
    .addMore_span{
      cursor: pointer;
      &:hover{
        color: #ed4040;
      }
    }
    span{
      color: #666666;
    }
  }
  .firstcolumn_tip{
    margin-top: 20px;
    height: 68px;
    border: 1px solid #f0f0f0;
    text-align: center;
    line-height: 68px;
    background-color: #fff;
    font-size: 24px;
    color: #353535;
    font-weight: 600;
    img{
      width:auto;
      height: 29px;
      margin-top: 20px;
    }
  }
  .leftBox{
    width: 880px;
    margin-right: 20px;
    margin-top: 20px;
    float: left;
    .bannerBox{
      width: 880px;
      height: 340px;
      font-size: 0;
      img{
        width:100%;
        height: 340px;
      }
    }
  }
  .rightBox{
    width: 300px;
    margin-top: 20px;
    float: right;
    overflow: hidden;
  }
  .newsBox {
    position: relative;
    width: 100%;
    background-color: #F9F9F9;
    .top {
      position: absolute;
      top: 0;
      width: 100%;
      height: 140px;
      top: -180px;
      background-color: #fff;
      z-index: 9;
      .navs {
        height: 40px;
        background-color: #7e6b5a;
        width: 100%;
        .w1200s {
          width: 1200px;
          height: 40px;
          background-color: #7e6b5a;
          margin: 0 auto;
          position: relative;
          .head-ul {
            display: inline-block;
            overflow: hidden;
            height: 40px;
            background-color: #7e6b5a;
            li {
              display: inline-block;
              margin-top: 10px;
              a {
                padding: 5px 14px;
                margin: 0 5px;
                cursor: pointer;
                color: #ffffff;
              }
            }
          }
          .right_box {
            display: inline-block;
            float: right;
            .login_register {
              border-radius: 5px;
              float: right;
              width: 88px;
              height: 28px;
              margin: 5px 20px;
              line-height: 28px;
              /*border: 1px solid #ed4040;*/
              a {
                display: inline-block;
                width: 42px;
                text-align: center;
                height: 16px;
                margin-top: 6px;
                font-size: 12px;
                line-height: 16px;
                color: #ffffff;
              }
            }
            .login_register a:nth-of-type(1) {
              border-right: 1px solid #fff;
            }
            .userBox {
              border-radius: 5px;
              width: 90px;
              height: 30px;
              margin: 5px 20px;
              line-height: 30px;
              transition: 0.5s;
              position: absolute;
              z-index: 5;
              right: 0;
              top: 0;
              overflow: hidden;
              &:hover {
                height: 240px;
              }
              .imgBox {
                width: 30px;
                height: 30px;
                border-radius: 50%;
                display: inline-block;
                background-color: #e6e6e6;
                vertical-align: top;
                cursor: pointer;
                font-size: 0;
                img {
                  width: 30px;
                  height: 30px;
                  border-radius: 50%;
                }
              }
              .usercontent {
                width: 150px;
                display: inline-block;
                height: 30px;
                font-size: 12px;
                color: #ffffff;
                /*overflow: hidden;*/
                margin-left: 5px;
                cursor: pointer;
                position: absolute;
                z-index: 6;
              }
              .list {
                margin-top: 10px;
                background-color: #fff;
                li {
                  text-align: center;
                  height: 36px;
                  line-height: 36px;
                  font-size: 12px;
                  cursor: pointer;
                  &:hover {
                    background-color: #ed4040;
                  }
                }
              }
            }
          }
        }
      }
      .logoBox {
        width: 444px;
        height: 60px;
        font-size: 0;
        display: inline-block;
        cursor: pointer;
        margin-top: 40px;
        vertical-align: top;
        img {
          width: 444px;
          height: 60px;
        }
      }
      .searchbox {
        display: inline-block;
        overflow: hidden;
        float: right;
        margin-top: 45px;
        span {
          display: inline-block;
          height: 38px;
          width: 98px;
          border: 1px solid #7e6b5a;
          vertical-align: top;
          text-align: center;
          line-height: 40px;
        }
        .keys_input {
          height: 38px;
          width: 313px;
          border-top: 1px solid #7e6b5a;
          border-bottom: 1px solid #7e6b5a;
          border-left: 1px solid #7e6b5a;
          padding-left: 5px;
          vertical-align: top;
        }
        .btn {
          display: inline-block;
          background-color: #7e6b5a;
          color: #ffffff;
          line-height: 40px;
          height: 40px;
          text-align: center;
          width: 101px;
          cursor: pointer;
        }
      }
      .bannerbox {
        width: 100%;
        height: 500px;
        font-size: 0;
        margin-top: 40px;
        position: relative;
        background-position: center center;
        background-size: auto 100%;
        img {
          width: 100%;
          height: 500px;
        }
        .numberCount {
          position: absolute;
          top: 332px;
          width: 100%;
          text-align: center;
          color: #bb955b;
          font-family: '微软宋体';
        }
      }
    }
  }
</style>
<!--手机端样式-->
<style rel="stylesheet/scss" lang="scss" scoped>
  @media screen and (max-width: 750px) {
    .top{
      display: none;
    }
    .leftBox{
      width: 100%;
      margin-top: 0;
      .bannerBox{
        width: 100%;
        height: auto;
        img{
          width: 100%;
          height: auto;
        }
      }
      .firstcolumn_tip{
        width: 100%;
        height: auto;
        background-color: #fff;
        text-align: center;
        img{
          width: 90%;
          height: auto;
        }
      }
      .columnBoxInnnerList{
        white-space: nowrap;
        padding: 0 20px;
      }
      .pushu_nav{
        width: 100%;
        overflow: hidden;
        padding-bottom: 20px;
        overflow-x: auto;
        span{
          float: none;
          margin: 0 auto 20px;
        }
      }
      .lilist{
        width: 100%;
        margin-left: 0;
        .tip{
          display: none;
        }
        .right_div{
          width: 100%!important;
          margin-left: 0!important;
          .puxi_content{
            width: 90%;
            padding-left: 5%;
          }
          .userMsg{
            img{
              margin-left: 10px;
            }
          }
        }

        .imgBox{
          display: inline-block;
          width: 100%;
          text-align: center;
        }
      }
    }
    .rightBox{
      display: none;
    }
  }
</style>

